// src/tokens.js

export const colors = {
  primary: "text-white",           // For header titles on indigo
  secondary: "text-indigo-700",    // For buttons on white
  accent: "text-amber-400",       // Highlight/CTA
  tertiary: "text-gray-700",       // Subdued labels
  background: "bg-indigo-100",     // Soft background
  surface: "bg-white",             // Main cards/surfaces
};

export const layout = {
  container: "max-w-screen-lg mx-auto",
  header: "bg-indigo-600 text-white shadow sticky top-0 z-50",
  headerTopRow: "flex items-center justify-between px-4 py-2 border-b border-indigo-500",
  headerBottomRow: "flex justify-around px-4 py-2 bg-indigo-700 text-xl",
};

export const buttons = {
  whitePurple: "bg-white text-indigo-700 px-3 py-1 rounded text-sm",
  purpleHover: "hover:bg-indigo-100",
  activePurple: "bg-indigo-600 text-white px-4 py-2 rounded-md text-sm",
  activePurpleSm: "bg-indigo-600 text-white px-4 py-1.5 rounded-md text-sm",
};

export const fontSizes = {
  sm: "text-sm",
  base: "text-base",
  lg: "text-lg",
  xl: "text-xl",
};

export const spacing = {
  sm: "p-2",
  md: "p-4",
  lg: "p-6",
  gapSm: "gap-2",
  gapMd: "gap-4",
  gapLg: "gap-6",
};

export const rounded = {
  sm: "rounded",
  md: "rounded-md",
  full: "rounded-full",
};
